import axios from '@/assets/js/axios.js'
import { APP_GUIDE_API } from './apis'
// 获取引导页列表
export function guideList (params) {
  return axios({
    url: APP_GUIDE_API.QUERY,
    method: 'post',
    data: params
  })
}
// 是否删除该引导页
export function isDel (params) {
  return axios({
    url: APP_GUIDE_API.DELETE,
    method: 'post',
    data: params
  })
}
// 是否删除该引导页
export function isUse (params) {
  return axios({
    url: APP_GUIDE_API.DISABLE,
    method: 'post',
    data: params
  })
}
// 根据ID获取引导页详情
export function guideDetail (params) {
  return axios({
    url: APP_GUIDE_API.DETAIL,
    method: 'post',
    data: params
  })
}
// 品牌列表
export function brandList (params) {
  return axios({
    url: APP_GUIDE_API.BRANDLIST,
    method: 'post',
    data: params
  })
}
// 品类列表
export function subCategoryList (params) {
  return axios({
    url: APP_GUIDE_API.SUB_CATEGORY_LIST,
    method: 'post',
    data: params
  })
}
// 获取型号
export function modelList (params) {
  return axios({
    url: APP_GUIDE_API.ALL_MODEL,
    method: 'post',
    data: params
  })
}
// 添加引导页
export function addGuide (params) {
  return axios({
    url: APP_GUIDE_API.ADD,
    method: 'post',
    data: params
  })
}
// 添加引导页
export function updateGuide (params) {
  return axios({
    url: APP_GUIDE_API.UPDATE,
    method: 'post',
    data: params
  })
}

// 显示未绑定的、未发布、已启用的产品
export function getFilterProduct (params) {
  return axios({
    url: APP_GUIDE_API.GET_FILTER_PRODUCT,
    method: 'post',
    data: params
  })
}
